export async function createUser(_identityClient) {  
  var identityResponse = await _identityClient.createUser();
  return identityResponse;
}
export async function getToken(user,_identityClient) {  
  var identityResponse = await _identityClient.getToken(user, ["chat", "voip"], { tokenExpiresInMinutes: 1440 });
  return identityResponse;
}

export async function createChatThread(topic, participants, chatClient) {
  const createChatThreadRequest = {
    topic: topic
  };
  const createChatThreadOptions = {
    participants: participants

  };
  const createChatThreadResult = await chatClient.createChatThread(
    createChatThreadRequest,
    createChatThreadOptions
  );
  const threadId = createChatThreadResult.chatThread.id;
  return threadId;
}
